<template>
  <div>
    <div class="row">
      <div class="col-3">
        dfghjk
        <tl-select
          class="customwidth"
          label="Salary Structure"
          labelText="name"
          name="headOfficeCity"
          data-vv-as="city"
          :options="salarystructure"
          :value="ss"
          @change="(val)=>fetchAllSalarycomponentsData(val.id)"
        ></tl-select>
        <div class="add-new" @click="addSalaryStructure">
          Add New
        </div>
      </div>
      <div class="col-3">
        <txt label="Enter CTC" type="number" v-model="salary.ctc"></txt>
      </div>
      <div class="col-3">
        <button class="export-button" @click="performAction()">Calculate</button>
      </div>
      <br />
    </div>
    <br />
    <tl-checkbox
      label="Exempt employee from IT deduction for the first month"
      v-model="salary.exempt_for_it_deduction_first_month"
    ></tl-checkbox>
    <br />
    <data-table
      :columns="columnNames"
      :tableData="ss.sssc"
      :checkbox="true"
      :withForm="false"
      :showhistory="false"
      :showedit="false"
      :selectedRecord="salary.master_salary_structure"
      @selected="selectedRecord"
      :showdelete="false"
    >
      <template v-slot:rowcontent="slotprops">
        <div>
          <p v-if="slotprops.value.column.key == 'name'">{{slotprops.value.record['scle']['name']}}</p>
          <p
            v-if="slotprops.value.column.key == 'formula'"
          >{{slotprops.value.record['scle']['formula']}}</p>
          <p
            v-if="slotprops.value.column.key == 'monthly'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p v-if="slotprops.value.column.key=='annual'">
            <txt
              v-model="slotprops.value.record[slotprops.value.column.key]"
              @change="(val)=>saveValues(val,slotprops.value.record,slotprops.value.index)"
            />
          </p>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      sendPayslip: false,
      exemptDeduction: true,
      extendRetDate: false,
      ss: {},
      salary: {
        salary_structure_id:"",
        exempt_for_it_deduction_first_month:false,
        master_salary_structure: []
      },
      selectedSalaryComponentList:[],
      salarystructureSelected: {},
      salarystructure: [],
      columnNames: [
        {
          label: "Pay Component",
          key: "name"
        },
        {
          label: "Calculation",
          key: "formula"
        },
        {
          label: "Monthly Amount ( in Rupees )",
          key: "monthly"
        },
        {
          label: "Annual Amount ( in Rupees)",
          key: "annual"
        }
      ],
      componentsData: [
        { name: "Basic", formula: "", amount: "123", annual: "54322" }
      ],
      ctc: ""
    };
  },
  watch: {
    salary: function(val) {
      //console.log(val)
      this.$emit("salary", val);
    },
    deep: true
  },
  mounted() {
    this.fetchAllSalaryStructureData();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {
    ...mapActions({
      act_fetchwithctc: "onboard/settings/salary_component/fetchwithctc",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:"onboard/settings/salary_component/fetchAllsalaryComponentsData"
    }),
    async performAction() {
      try {
        let res = await this.act_fetchwithctc({
          salaryComponents: this.salary.salary_structure_id,
          ctc: this.ctc
        });
        //console.log("DONE", this.salary.tabledata);
      } catch (err) {
        //console.log(err);
      }
    },

    addSalaryStructure() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/addStructure`
      })
    },

      async fetchAllSalarycomponentsData(ssid) {
        let queryParam={
          le_id:this.le_id,
          ss_id:ssid
        }
        try {
          let res = await this.act_fetchsalarycomponents(queryParam);
          //console.log("salary structure", res.data.payload);
          this.ss = res.data.payload;
          this.salary.salary_structure_id = this.ss.id
          this.salary.master_salary_structure = [];
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },

    async fetchAllSalaryStructureData() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        //console.log("salary structure", res.data.payload);
        this.salarystructure = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    selectedRecord(records){
      this.salary.master_salary_structure = [];
      let Obj = {}
      if(records.length){
        for(let record of records)
        {
          Obj['salary_component_id']= record.scle ? record.scle.id : null,
          Obj['name']=record.scle ? record.scle.name : null,
          Obj['abbreviation']=record.scle ? record.scle.abbreviation : null,
          Obj['total']=record.total ? record.total : ""
          this.salary.master_salary_structure.push(Obj);
        }
      }
        //console.log('record',this.salary.master_salary_structure);
    },
    saveValues(val, record, index) {
          record['total']=val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.radio-container {
  display: flex;
  flex-direction: column;
  margin: 25px 0px 25px 0px;
  color: #404040;
  font-size: $font-size-small;
  *:nth-child(n) {
    margin-bottom: 10px;
  }
}
.radio-btn {
  display: flex;
  *:nth-child(n) {
    margin-right: 20px;
  }
}
.form-grid {
  display: grid;
  grid-template-columns: 40px auto auto auto auto;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.custom-margin {
  margin-top: 8%;
}
.add-new {
  color: $color-primary;
  text-decoration: underline;
  font-size: $font-size-small;
  cursor: pointer;
}
</style>
